import {Injectable} from '@angular/core';
import {ToastrService} from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(private toast: ToastrService) {
  }

  error(title: string = '', message: string = '') {
    this.toast.error(message, title);
  }

  success(title: string = '', message: string = '') {
    this.toast.success(message, title);
  }
}
